/**
 * 认证工具函数
 */

/**
 * 获取存储在 localStorage 中的 token 键名
 */
export const getJWTStorageKey = (): string => {
  return (import.meta as any).env?.VITE_REACT_APP_JWT_STORAGE_KEY || "token";
};

/**
 * 获取认证 token
 */
export const getToken = (): string | null => {
  const key = getJWTStorageKey();
  return localStorage.getItem(key);
};

/**
 * 检查用户是否已登录（是否存在 token）
 */
export const isAuthenticated = (): boolean => {
  return !!getToken();
};

/**
 * 清除认证信息
 */
export const clearAuth = (): void => {
  const key = getJWTStorageKey();
  localStorage.removeItem(key);
};

/**
 * 设置 token（用于某些特殊情况）
 */
export const setToken = (token: string): void => {
  const key = getJWTStorageKey();
  localStorage.setItem(key, token);
};
